import React, { useState } from 'react';
import styled from 'styled-components';

// IMPORTY ZDJĘĆ
import salon from '../images/salon.jpg'
import sauna from '../images/sauna.jpeg'
import sypialnia from '../images/sypialnia.jpg'
import pokoj from '../images/pokoj.jpg'
import lazienka from '../images/lazienka.jpeg'
import ogrod from '../images/ogrod.jpg'
import kuchnia from '../images/kuchnia.jpg'
import domek from '../images/domek.jpg'
import domki1 from '../images/domki1.jpg'
import domki2 from '../images/domki2.jpg'
import domki from '../images/domki.jpg'

// STYLES
const GalleryContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.blackWhite};
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 30px;
  padding: 20px 5rem;

  @media (max-width: 440px) {
    padding: 10px;
  }

  @media (max-width: 320px) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  cursor: pointer;
  height: 250px;
  overflow: hidden;
  border-radius: 10px;

  :hover {
    opacity: 0.8;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const FullscreenImage = styled.img`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  cursor: pointer;
`;

// KOMPONENT
function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    { src: salon, alt: "Salon" },
    { src: domki, alt: "Domki" },
    { src: domki1, alt: "Domki front" },
    { src: kuchnia, alt: "Kuchnia" },
    { src: ogrod, alt: "Ogród" },
    { src: pokoj, alt: "Pokój" },
    { src: sypialnia, alt: "Sypialnia" },
    { src: lazienka, alt: "Łazienka" },
    { src: sauna, alt: "Sauna" },
    { src: domek, alt: "Domek" },
    { src: domki2, alt: "Domki 2" },
  ];

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.documentElement.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <div>
      <GalleryContainer>
        {galleryImages.map((img, index) => (
          <ImageWrapper key={index} onClick={() => openLightbox(img.src)}>
            <img src={img.src} alt={img.alt} />
          </ImageWrapper>
        ))}
      </GalleryContainer>

      {selectedImage && (
        <FullscreenImage
          src={selectedImage}
          alt="Preview"
          onClick={closeLightbox}
        />
      )}
    </div>
  );
}

export default Gallery;